import { get, mapValues } from 'lodash';
import useEntityFormContext from './internal/useEntityFormContext';
const useDependsOnFields = (fields) => {
    const { values } = useEntityFormContext();
    return mapValues(fields, (fieldName) => get(values, fieldName, undefined));
};
export default useDependsOnFields;
